<template>
	<ul class="d-none d-lg-block" :class="fromPdp?'pl-1':''">
		<li class="text-left">
			<small>
				<router-link :to="{path: '/'}" id="breadcrumb-home-link" data-test="breadCrumbHomeLink">Home</router-link>
				<span
					id="breadcrumb-home-span"
					v-if="$route.path === '/all-products'"
					class="breadcrumb-navigator"
					data-test="breadCrumbAllPdtsSpan"
				>&gt;</span>
				<router-link
					class="router-link-active"
					v-if="$route.path === '/all-products'"
					:to="{
											name: 'AllProducts',
											path: '/all-products',
											query: {
											display_text: 'All Products',
											called_index_value: 0,
											called_count_value: 1500,
											product_length: 1500,
											},
										}"
					id="breadcrumb-all-products"
					data-test="breadCrumbAllPdtsLink"
				>AllProducts</router-link>
				<slot v-if="$route.path !== '/all-products'">
						<span v-for="(category, i) in categories" :key="i">
								<span class="breadcrumb-navigator"
														:data-test="'breadCrumbCategorySpan'+i"
														:id="'breadCrumbCategorySpan'+i"
								>></span>
								<a
									href
									@click.prevent="getCategory(category)"
									:data-test="'breadCrumbCategoryParentName'+i"
									:id="'breadCrumbCategoryParentName'+i"
								>{{category.parent_name.length>50? category.parent_name.substr(0,50)+'...' : category.parent_name}}
								</a>
						</span>
				</slot>
				<span class="breadcrumb-navigator"
										data-test="breadCrumbActiveCategorySpan2"
										v-if="productName"
										id="breadCrumbActiveCategorySpan2">></span>
					<a
						href="javascript:void(0)"
						v-if="productName && productName.length"
						data-test="breadCrumbActiveCategoryLink2"
						id="breadCrumbActiveCategoryLink2"
					>
						{{productName.length > 15?productName.substr(0,15)+'...' :productName}}
				</a>
			</small>
			<small id="breadcrumb-product-found" data-test="breadCrumbPdtLength" v-if="!fromPdp">
				{{productsLength}} Product
				{{productsLength === 1 ||
				productsLength === 0 ? '':'s' }} found
			</small>
		</li>
	</ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'bread-crumb',
	props: {
		activeCategory: {
			type: Array
		},
		productsLength: {
			type: Number,
			default: 0
		},
		productName: {
			type: String,
			default: ''
		},
		fromPdp: {
			type: Boolean,
			default: false
		}
	},
	mounted () {
		this.categoryData()
	},
	data () {
		return {
			categoryIndex: 0,
			categories: [],
			index: 0
		}
	},
	computed: {
		...mapGetters('category', ['getActiveCategories'])
	},
	watch: {
		getActiveCategories: {
			handler (val) {
				this.$nextTick(() => {
					// this.categories = this.getActiveCategories;
					this.categoryData()
				})
			},
			deep: true
		}
	},
	methods: {
		categoryData () {
			this.categories = this.getActiveCategories.slice(0, this.$route.query.depth)
		},
		getCategory (classifications) {
			this.$nextTick(() => {
				this.$router.push({
					name: 'ProductList',
					path: '/product-list',
					query: {
						category: classifications.parent_id,
						name: classifications.parent_name,
						depth: classifications.depth,
						display_text: classifications.parent_name,
						is_a_category: true
					}
				})
			})
		}
	}
}
</script>

<style scoped>

</style>
